var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.59,325.25l-13.12.28-6.66.11c-2.23.05-4.47,0-6.7.05h-.44v-.45l-.06-11.19v-.5h.5l13.24.06c4.42,0,8.83.11,13.24.17h.28v.27c0,1.9-.09,3.79-.13,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.82.16-13.24.17l-13.24.06.5-.5,0,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.82,339.36l-13.12.28-6.66.11c-2.23.05-4.47,0-6.7.05H40.9v-.45l-.06-11.19v-.5h.5l13.24.06c4.41,0,8.83.11,13.24.17h.28v.27c0,1.9-.08,3.79-.13,5.65Zm0,0-.14-5.66c-.05-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.83.16-13.24.17l-13.24.06.5-.5-.05,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.11,365.11l-13.12.28-6.66.11c-2.23.05-4.47,0-6.7.06h-.44v-.45l-.05-11.19v-.5h.5l13.24.06c4.41,0,8.83.12,13.24.17h.28v.27c0,1.9-.08,3.79-.13,5.65Zm0,0-.14-5.65c-.05-1.87-.11-3.71-.13-5.54l.27.27c-4.41.05-8.83.16-13.24.17l-13.24.06.5-.5,0,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.34,379.22l-13.13.28-6.66.11c-2.22.05-4.46,0-6.69.06h-.44v-.45l0-11.19v-.5h.5l13.24.06c4.41,0,8.83.12,13.24.17h.28V368c0,1.9-.08,3.79-.13,5.65Zm0,0-.14-5.65c0-1.87-.11-3.71-.13-5.54l.27.27c-4.41.05-8.83.16-13.24.17l-13.24.06.5-.5-.06,11.19-.44-.45c2.18,0,4.36,0,6.54.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.63,365.11l-13.13.28-6.66.11c-2.23.05-4.46,0-6.69.06h-.45v-.45l0-11.19v-.5h.51l13.24.06c4.41,0,8.82.12,13.24.17h.27v.27c0,1.9-.09,3.79-.13,5.65Zm0,0-.15-5.65c0-1.87-.11-3.71-.13-5.54l.28.27c-4.42.05-8.83.16-13.24.17l-13.24.06.49-.5,0,11.19-.44-.45c2.18,0,4.35,0,6.54.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.66,339.36l-13.13.28-6.66.11c-2.22.05-4.46,0-6.69.05h-.45v-.45l-.05-11.19v-.5h.5l13.24.06c4.41,0,8.83.11,13.24.17h.27v.27c0,1.9-.08,3.79-.13,5.65Zm0,0-.14-5.66c0-1.86-.12-3.7-.13-5.53l.27.27c-4.41.05-8.83.16-13.24.17l-13.24.06.5-.5-.06,11.19-.44-.45c2.18,0,4.36,0,6.54.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.89,56.92l-13.13.27-6.66.12c-2.22,0-4.46,0-6.69,0H417v-.44l0-11.19v-.51h.51l13.24.06c4.41,0,8.82.11,13.24.16h.27v.27c0,1.89-.09,3.78-.13,5.65Zm0,0-.14-5.66c-.05-1.86-.12-3.7-.14-5.53l.28.27c-4.42,0-8.83.16-13.24.16l-13.24.07.5-.5-.06,11.19-.44-.45c2.18,0,4.35,0,6.54.05l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.66,71l-13.13.27-6.66.12c-2.22,0-4.46,0-6.69,0h-.45V71l-.05-11.19v-.51h.5l13.24.06c4.41,0,8.83.11,13.24.16h.27v.27c0,1.89-.08,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.12-3.7-.13-5.53l.27.27c-4.41,0-8.83.16-13.24.16l-13.24.06.5-.49L432.62,71l-.44-.45c2.18,0,4.36,0,6.54,0l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.82,56.92l-13.12.27L48,57.31c-2.23,0-4.47,0-6.7,0H40.9v-.44l-.06-11.19v-.51h.5l13.24.06c4.41,0,8.83.11,13.24.16h.28v.27c0,1.89-.08,3.78-.13,5.65Zm0,0-.14-5.66c-.05-1.86-.11-3.7-.13-5.53l.27.27c-4.41,0-8.83.16-13.24.16l-13.24.07.5-.5-.05,11.19-.45-.45c2.18,0,4.36,0,6.55.05l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.48,
    width: 1,
    height: 87.64,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.41 116.98 97.96 122.36 41.99 122.36 39.55 116.98 63.38 100.48 76.58 100.48 100.41 116.98",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.23 84.59 76.58 100.48 63.38 100.48 61.72 84.59 78.23 84.59",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.41 116.98 97.96 122.36 41.98 122.36 39.54 116.98 100.41 116.98",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.82,
    width: 1,
    height: 70.28,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.75 99.62 163.31 105 107.33 105 104.89 99.62 128.72 83.12 141.92 83.12 165.75 99.62",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.58 67.23 141.92 83.12 128.72 83.12 127.07 67.23 143.58 67.23",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.75 99.62 163.3 105 107.33 105 104.89 99.62 165.75 99.62",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.07,
    y: 241.24,
    width: 104.03,
    height: 143.97,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.03,
    y: 235.9,
    width: 114.11,
    height: 5.34,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.14,
    y: 235.9,
    width: 35.89,
    height: 5.34,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.1,
    y: 241.24,
    width: 35.25,
    height: 143.97,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.9,307.87H326.27V261.74H407.9Zm-81.38-.25h81.13V262H326.52Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.69,
    y: 275.22,
    width: 15.89,
    height: 9.13,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.41,283.79H360.27v-8h16.14Zm-15.89-.25h15.64V276H360.52Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.9,365.83H326.27V319.7H407.9Zm-81.38-.25h81.13V320H326.52Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.69,
    y: 333.18,
    width: 15.89,
    height: 9.13,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.41,341.75H360.27v-8h16.14Zm-15.89-.25h15.64V334H360.52Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--ZZtZDI--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.15,265.15a8.38,8.38,0,0,1-4,2.09c-1,.24-1.92.37-2.88.55H113c-1.35-.21-2.7-.37-4-.64a37.84,37.84,0,0,1-13.71-6A88.87,88.87,0,0,1,68.41,233.4a34.44,34.44,0,0,1-4.64-12c-.19-1.12-.35-2.25-.52-3.37v-3.29c.27-1.26.49-2.54.83-3.78a7.06,7.06,0,0,1,1.8-3.09c.16.14.31.26.45.4Q74.18,216.14,82,224a1,1,0,0,1,.3,1.19,7.78,7.78,0,0,0,1.7,7.53A158.63,158.63,0,0,0,98.34,247a7.82,7.82,0,0,0,7.6,1.67c.37-.09.65-.16,1,.17q8,8.05,16.07,16.08C123,265,123.07,265.05,123.15,265.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.41,253.4v1.1c-.51.65-1,1.36-1.54,2-1.62,1.67-3.28,3.3-4.93,4.94l-.5.48L110.3,245.75c2.11-2.08,4.22-4.22,6.4-6.29a2.38,2.38,0,0,1,3.45.18c1.21,1.17,2.39,2.38,3.59,3.58,2.8,2.8,5.62,5.6,8.41,8.43A14.67,14.67,0,0,1,133.41,253.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.11,214.84c-2,1.93-4,3.82-6,5.69l-16-16c.36-.32.76-.65,1.13-1,1.47-1.46,2.92-3,4.42-4.4a21.57,21.57,0,0,1,1.91-1.48h1.1a14.87,14.87,0,0,1,1.74,1.26c3.93,3.89,7.82,7.8,11.72,11.71C92.58,212.08,92.61,213.4,91.11,214.84Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 331.56,
    y: 44.96,
    width: 105.19,
    height: 58.86,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.88 103.82 331.56 103.82 331.56 83.32 311.88 103.82",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.98,
    y: 75.69,
    width: 70.38,
    height: 1.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.98,
    y: 82.54,
    width: 55.91,
    height: 1.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.98,
    y: 62,
    width: 60.13,
    height: 1.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.98,
    y: 55.15,
    width: 78.5,
    height: 1.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.98,
    y: 89.39,
    width: 61.71,
    height: 1.27,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-8"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 276.99,
    cy: 441.38,
    rx: 171.13,
    ry: 18.69,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87,276.61a42.91,42.91,0,0,1-.84,16.51,45.78,45.78,0,0,1-2.53,7.31c-1.32,3-2.69,6-2.36,9.27.32.22-.77.18-.81-.14-8.84-5-20.17-5.95-27-14.18-3.22-3.89-4.84-8.83-5.61-13.77-.84-5.37-1.07-11.33.31-16.63,1.17-4.48,3.79-8.8,8-11s10-2.07,14.62-.65C80.7,256.4,85.61,267.05,87,276.61Z",
    style: {
      fill: "#F9BF21"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.54,342c-1.21-4-2.41-8-3.65-12-2.42-7.85-4.94-15.68-7.73-23.41q-2.5-6.94-5.29-13.76a82.26,82.26,0,0,1,1-8.54c.74-3.43,1.81-6.74,2.81-10.09.07-.21-.27-.32-.35-.12-2,4.62-4.58,10.53-4.64,16-2.16-5.14-4.46-10.21-6.95-15.2a65.45,65.45,0,0,1,.39-12.66.15.15,0,0,0-.29-.06A44.35,44.35,0,0,0,66,273.3c-1.9-3.75-3.9-7.45-6-11.1-.19-.33-.64,0-.48.33,3.32,6.4,6.4,12.93,9.29,19.54a42.38,42.38,0,0,0-13.85-8c-.22-.08-.39.24-.16.33a50.59,50.59,0,0,1,15,9.92q3.12,7.27,5.94,14.65c-5.53-5.42-13.09-9-20.41-10.9-.25-.06-.32.32-.08.39,8.47,2.55,15,7.35,21.49,13.12q1.13,3,2.21,6,4.1,11.35,7.79,22.85,1.79,5.5,3.51,11c1.24,4,2.2,8.15,3.81,12,.16.36.81.28.73-.16A116.51,116.51,0,0,0,91.54,342Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.88,268.87a22,22,0,0,0-3.18,7.93c0,.08.1.12.13.05a66.82,66.82,0,0,1,3.45-7.79C77.41,268.8,77,268.64,76.88,268.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.12,287.28a23.25,23.25,0,0,0-7.93-2.67c-.07,0-.12.1,0,.13,1.27.53,2.61.9,3.9,1.39s2.56,1.11,3.87,1.56A.23.23,0,0,0,61.12,287.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.68,265.13a15.61,15.61,0,0,0-2.55-1.57.14.14,0,0,0-.15.22,15.09,15.09,0,0,0,2.52,1.63C56.66,265.51,56.84,265.24,56.68,265.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.79,306.62c-6.36,1.89-12.76,3.63-19.12,5.5-.55.17-11.31-20.45-7.42-31.07,3.59-9.83,11.82-17.19,21.63-20.53,4.54-1.54,10.13-2.84,14.93-1.78,4.27.95,7.28,4.44,8.67,8.46,1.89,5.45,1.26,12,.23,17.53A30.58,30.58,0,0,1,129.45,299C126.07,303.06,121.76,305.15,116.79,306.62Z",
    style: {
      fill: "#F9BF21"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,287a85.33,85.33,0,0,1-12.48,4.91,52.94,52.94,0,0,0-8.33,3c2.69-6,5.64-11.86,8.77-17.67,4.11-1.19,8.44-3,11.54-5.95a.18.18,0,0,0-.24-.27c-3.39,2.39-7.13,3.83-10.88,5.45.85-1.56,1.7-3.12,2.57-4.68.25-.44-.35-.87-.64-.44a134.19,134.19,0,0,0-9,15.18,69.47,69.47,0,0,1-.65-13.91c0-.12-.17-.13-.19,0a46.7,46.7,0,0,0,.16,15.29c-2.23,4.46-4.26,9-6.09,13.64-.73-2.77-1.67-5.51-2.3-8.31A38.24,38.24,0,0,1,97.3,281c0-.12-.17-.12-.19,0a43.24,43.24,0,0,0,2.67,22.49c-1.06,2.78-2.08,5.57-3,8.37A166.65,166.65,0,0,0,88.33,356a.27.27,0,0,0,.54,0,218.37,218.37,0,0,1,9.48-43.64c1.85-5.55,4-10.94,6.3-16.22,3.76-1.11,7.5-2.62,11.2-3.9a35.1,35.1,0,0,0,10.31-5.06C126.28,287.15,126.15,287,126,287Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,281c-3.9,1.38-7.59,3.32-11.47,4.72-.19.07-.08.36.1.32,4.12-.85,8.2-2.12,11.51-4.82C132.23,281.16,132.09,281,132,281Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.17,272.64c0-.21-.25-.33-.31-.11-1.07,3.58-1.81,7.39-.77,11.06,0,.14.27.15.28,0C99.55,279.88,99.35,276.28,100.17,272.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.26,264.35a9.45,9.45,0,0,0-1.69,6.1c0,.14.22.22.26.06.47-2.06,1.27-3.93,1.9-5.92A.27.27,0,0,0,116.26,264.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.09,315.71c1.87,5.92,6.3,14.11,13.32,14.17,4.56.05,9.14-.49,13.7-.56,4.89-.07,9.78-.06,14.66.23.4,0-.59-14.63-12.33-21.77-3.29-2-7.31-2.63-11-3.44a51.66,51.66,0,0,0-13-1.36c-2.7.11-4.94.68-5.9,3.44S40.2,312.9,41.09,315.71Z",
    style: {
      fill: "#F9BF21"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.15,308.3c2.85.73,5.73,1.58,8.59,2.49a28.59,28.59,0,0,0-2.36-2.31c-1.23-1-2.59-1.84-3.91-2.74-.11-.07,0-.28.1-.23A16.15,16.15,0,0,1,55.5,311c3.57,1.15,7.1,2.43,10.5,3.82a40.15,40.15,0,0,1,6.73,3.54,27.74,27.74,0,0,0-2.43-4.23c-1.56-2-3.67-3.15-5.71-4.58a.18.18,0,0,1,.18-.31,16.71,16.71,0,0,1,9.16,9.93,39,39,0,0,1,6.66,6.05c7.77,8.82,13.89,20.56,13.91,32.54,0,.29-.46.37-.51.07A66.43,66.43,0,0,0,79.17,326c-.56-.65-1.13-1.27-1.71-1.87a52.72,52.72,0,0,0-6.42-.47c-2.5,0-5,.36-7.46.57-4.1.33-8.64.38-12.33-1.69a.16.16,0,0,1,.13-.3c8.24,3,16.88-.81,25.15,1a38.64,38.64,0,0,0-12.19-7.86l-.76-.3c-5.29.63-10.87,2-16,.29a.12.12,0,1,1,.06-.24c5,1.24,9.76-.32,14.67-.57-5.35-2.08-10.8-3.74-16.17-5.81C45.67,308.59,45.66,308.18,46.15,308.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.81,313.51a71.24,71.24,0,0,0,7.7.58c.06,0,.08.1,0,.11a15.89,15.89,0,0,1-7.77-.5C43.63,313.67,43.69,313.49,43.81,313.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2,308.43A12.56,12.56,0,0,1,65,311.08c.14.12,0,.36-.19.25-.65-.47-1.31-.91-2-1.35A18.76,18.76,0,0,1,61,308.81C60.81,308.67,61,308.36,61.2,308.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.66,327.5c-.08.19.2.37.31.17h0a.27.27,0,0,0,.18.12,118.64,118.64,0,0,0,14.35,2.5c3.88.34,8.35.56,11.75-1.7,4.61-3.05,7.64-11.21,5.15-16.4-2.95-6.16-11.82-2.81-16.28-.62A32.66,32.66,0,0,0,102.66,327.5Z",
    style: {
      fill: "#F9BF21"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.22,330.34a46,46,0,0,1,8.57-6.52,29.42,29.42,0,0,1,8.68-8.85c.17-.12.31.15.16.27a39.23,39.23,0,0,0-7.32,7.7,80.82,80.82,0,0,1,10.75-4.89,14.21,14.21,0,0,1,5.77-5.78s.11,0,.06.08a23.5,23.5,0,0,0-5.21,5.47c2.18-.82,4.38-1.58,6.59-2.31.2-.06.27.24.08.31-3.92,1.53-7.93,3.15-11.82,5a45.26,45.26,0,0,0,14.32,0,.11.11,0,0,1,.05.21,28.19,28.19,0,0,1-15.19.22,70.28,70.28,0,0,0-7.2,4,18,18,0,0,1,5.82.48,45.3,45.3,0,0,0,10.24,1.16.12.12,0,0,1,0,.23c-5.94,1-11.55-1.68-17.44-1a45.28,45.28,0,0,0-6.13,5,46.21,46.21,0,0,0-8.93,12.61c-2.48,5-3.82,10.38-5.82,15.59a.19.19,0,0,1-.37-.1C86.63,349,91.74,337.66,99.22,330.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.13,316.26a6.74,6.74,0,0,1,1.52-1.85,6.08,6.08,0,0,1,1.75-1.31c.06,0,.09.06.06.1-.49.55-1.17,1-1.69,1.49s-1,1.15-1.51,1.68A.09.09,0,0,1,117.13,316.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.92,319.45c.88-.22,1.81-.21,2.7-.39a26.53,26.53,0,0,0,2.63-.79.11.11,0,0,1,.08.2,8.78,8.78,0,0,1-5.41,1.25C126.78,319.7,126.79,319.48,126.92,319.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.76 346.6 75.54 355.45 78.18 385.33 101.58 385.33 104.89 355.45 105.86 346.6 74.76 346.6",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.76 346.6 75.54 355.45 104.89 355.45 105.86 346.6 74.76 346.6",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.44,
    y: 344.19,
    width: 35.74,
    height: 7.18,
    transform: "translate(180.62 695.56) rotate(180)",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "39.97 385.21 92.48 384.96 144.99 384.88 250 384.71 355.01 384.88 407.52 384.96 460.03 385.21 407.52 385.45 355.01 385.54 250 385.71 144.99 385.54 92.48 385.45 39.97 385.21",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.27,75.32H142.62A16.51,16.51,0,0,0,126.27,92V424.74a16.51,16.51,0,0,0,16.35,16.65H304.27a16.52,16.52,0,0,0,16.37-16.65V92A16.52,16.52,0,0,0,304.27,75.32Zm6.14,339.13c0,8.76-6.56,15.84-14.65,15.84H151.15c-8.11,0-14.67-7.08-14.67-15.84V104.59c0-17.84,6.56-18.71,14.67-18.71h29c1.69,0,3.06,1.91,3.06,4.28v1c0,5.55,3,5.57,6.77,5.57h67c3.77,0,6.79,0,6.79-5.57v-1c0-2.37,1.36-4.28,3.07-4.28h29c8.09,0,14.65,2.37,14.65,18.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.41,104.59V414.45c0,8.76-6.56,15.84-14.65,15.84H151.15c-8.11,0-14.67-7.08-14.67-15.84V104.59c0-17.84,6.56-18.71,14.67-18.71h29c1.69,0,3.06,1.91,3.06,4.28v1c0,5.55,3,5.57,6.77,5.57h67c3.77,0,6.79,0,6.79-5.57v-1c0-2.37,1.36-4.28,3.07-4.28h29C303.85,85.88,310.41,88.25,310.41,104.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--u5Zjqx--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.12,92.84c-.09.09-.19.18-.28.28l-.16.15A3.77,3.77,0,0,0,172,92.16a3.72,3.72,0,0,0-2.7,1.12l-.15-.16c-.1-.09-.19-.19-.28-.28h0l0,0c.12-.1.23-.21.36-.31A3.85,3.85,0,0,1,170,92a4.25,4.25,0,0,1,1.09-.37l.54-.07h.48l.37,0a4.21,4.21,0,0,1,1,.24,5.11,5.11,0,0,1,.67.31,5,5,0,0,1,.65.45l.29.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.17,94.15l-.44-.43a3.18,3.18,0,0,1,4.51,0l-.45.44a2.53,2.53,0,0,0-1.8-.75A2.58,2.58,0,0,0,170.17,94.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.35,94.6l-.44.44a1.29,1.29,0,0,0-1.85,0l-.44-.44A1.92,1.92,0,0,1,173.35,94.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.38,95.44a.39.39,0,0,1-.39.39.4.4,0,1,1,0-.79A.39.39,0,0,1,172.38,95.44Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M147.83,93.68A1.15,1.15,0,1,1,149,94.84,1.15,1.15,0,0,1,147.83,93.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.46,93.68a1.15,1.15,0,1,1,1.15,1.16A1.16,1.16,0,0,1,151.46,93.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.09,93.68a1.16,1.16,0,1,1,1.15,1.16A1.16,1.16,0,0,1,155.09,93.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.72,93.68a1.16,1.16,0,1,1,1.15,1.16A1.16,1.16,0,0,1,158.72,93.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.35,93.68a1.16,1.16,0,1,1,1.15,1.16A1.16,1.16,0,0,1,162.35,93.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.37,96.2H288V91.85h9.39Zm-8.91-.48h8.43V92.33h-8.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.76,
    y: 92.59,
    width: 6.05,
    height: 2.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.37,
    y: 92.86,
    width: 0.83,
    height: 2.33,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.59,89.82H214.32a1.12,1.12,0,0,1-1.13-1.13h0a1.13,1.13,0,0,1,1.13-1.13h18.27a1.14,1.14,0,0,1,1.13,1.13h0A1.13,1.13,0,0,1,232.59,89.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.88,192.25a7.2,7.2,0,0,1,11.62-5.51,1.12,1.12,0,0,1,.22,1.58,1.14,1.14,0,0,1-1.58.17,5.08,5.08,0,0,0-3.07-1.05,4.86,4.86,0,0,0-3.51,1.42,4.62,4.62,0,0,0,0,6.74,4.86,4.86,0,0,0,3.51,1.42,5.33,5.33,0,0,0,2.66-.74v-2.67H173a1.12,1.12,0,0,1-1.11-1.11,1.1,1.1,0,0,1,1.11-1.09h3.87A1.1,1.1,0,0,1,178,192.5v4.3a1.5,1.5,0,0,1-.06.33s0,.06,0,.1v0a.86.86,0,0,1-.37.47,7.18,7.18,0,0,1-4.41,1.52A7.08,7.08,0,0,1,165.88,192.25Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.45,194.37a4.82,4.82,0,0,1,4.75-4.87,4.66,4.66,0,0,1,4.69,4.52v.1a.5.5,0,0,1,0,.17.94.94,0,0,1-1,.78h-6.19a2.5,2.5,0,0,0,.66,1.29,3,3,0,0,0,1.87.87,3.16,3.16,0,0,0,2-.48,1.1,1.1,0,0,1,1.46-.06.88.88,0,0,1,0,1.26,4.89,4.89,0,0,1-3.48,1.29A4.83,4.83,0,0,1,181.45,194.37Zm2.12-1h5.51a3.2,3.2,0,0,0-2.88-2.07A2.72,2.72,0,0,0,183.57,193.42Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.59,190.57a1.1,1.1,0,0,1-1.09,1.08H196v5.43a1.06,1.06,0,0,1,1.07,1.09,1.05,1.05,0,0,1-1.07,1.07,2.18,2.18,0,0,1-2.16-2.16v-5.43h-.56a1.07,1.07,0,0,1-1.07-1.08,1.05,1.05,0,0,1,1.07-1.07h.56v-2.82a1.08,1.08,0,0,1,1.09-1.07,1.05,1.05,0,0,1,1.07,1.07v2.82h.49A1.09,1.09,0,0,1,197.59,190.57Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,187.07a1.05,1.05,0,0,1-1.05,1.07,1.07,1.07,0,0,1-1.06-1.07v-.41a1.05,1.05,0,0,1,1.06-1,1,1,0,0,1,1.05,1Zm0,3.52v7.6a1,1,0,0,1-1.05,1.05,1.05,1.05,0,0,1-1.06-1.05v-7.6a1,1,0,0,1,1.06-1.07A1,1,0,0,1,209,190.59Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.44,193.55v4.66a1,1,0,0,1-1,1,1.06,1.06,0,0,1-1-1v-4.66a2,2,0,0,0-2-2,1.94,1.94,0,0,0-2,2v4.66a.38.38,0,0,1,0,.19,1.06,1.06,0,0,1-1,.84,1,1,0,0,1-1-1v-7.67a1,1,0,0,1,1-1,1,1,0,0,1,1,.61,3.93,3.93,0,0,1,2.07-.61A4.08,4.08,0,0,1,220.44,193.55Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.48,190.57a1.1,1.1,0,0,1-1.09,1.08h-.49v5.43a1.08,1.08,0,1,1,0,2.16,2.18,2.18,0,0,1-2.16-2.16v-5.43h-.56a1.07,1.07,0,0,1-1.07-1.08,1.06,1.06,0,0,1,1.07-1.07h.56v-2.82a1.08,1.08,0,0,1,1.09-1.07,1.05,1.05,0,0,1,1.07,1.07v2.82h.49A1.08,1.08,0,0,1,234.48,190.57Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.5,197.82a4.87,4.87,0,0,1-1.35-3.43A5,5,0,0,1,238.5,191a4.54,4.54,0,0,1,3.34-1.48A4.34,4.34,0,0,1,245.1,191a4.91,4.91,0,0,1,1.36,3.41,4.75,4.75,0,0,1-1.36,3.43,4.34,4.34,0,0,1-3.26,1.48A4.54,4.54,0,0,1,238.5,197.82Zm.78-3.43a3.11,3.11,0,0,0,.7,2.06,2.61,2.61,0,0,0,1.86.72,2.55,2.55,0,0,0,1.8-.72,3,3,0,0,0,.76-2.06,2.93,2.93,0,0,0-.76-2,2.75,2.75,0,0,0-1.8-.74,2.81,2.81,0,0,0-1.86.74A3,3,0,0,0,239.28,194.39Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.32,199.24a4.07,4.07,0,0,1-4-4.05v-4.65a1.06,1.06,0,0,1,1-1,1,1,0,0,1,1,1v4.65a2,2,0,0,0,2,2,2,2,0,0,0,2-2v-4.65a1,1,0,0,1,1-1,1.09,1.09,0,0,1,1.06,1v4.65A4.11,4.11,0,0,1,253.32,199.24Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.72,194.39a5,5,0,0,1,4.95-4.89,5.13,5.13,0,0,1,3.09,1.07A1.07,1.07,0,0,1,269,192a1,1,0,0,1-1.46.2,3.11,3.11,0,0,0-1.85-.62,2.79,2.79,0,1,0,0,5.58,3.16,3.16,0,0,0,1.85-.62,1.06,1.06,0,0,1,1.46.22,1.08,1.08,0,0,1-.22,1.44,5.37,5.37,0,0,1-3.09,1A4.93,4.93,0,0,1,260.72,194.39Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.69,198.17a1.08,1.08,0,0,1-1.09,1.07,1.11,1.11,0,0,1-1-.8,2.23,2.23,0,0,1,0-.27V186.68a1.06,1.06,0,0,1,1.07-1.07,1.08,1.08,0,0,1,1.09,1.07v3.39a4.43,4.43,0,0,1,2.08-.57,4.25,4.25,0,0,1,4.24,4.27v4.4a1.07,1.07,0,0,1-2.14,0v-4.4a2.09,2.09,0,1,0-4.18,0Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.16,
    y: 210.29,
    width: 138.57,
    height: 137.85,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.73,348.14l-138.57.06h-.06v-.06L154,210.29v-.13h.12l138.57.06h.07v.07Zm0,0-.06-137.85.06.06-138.57.06.13-.12-.06,137.85-.07-.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.17,227.51a.33.33,0,1,1-.66,0V224h0a.33.33,0,0,1,.14-.27.31.31,0,0,1,.45.07L169,226.5V224a.33.33,0,0,1,.66,0v3.49a.33.33,0,0,1-.58.21l0,0L167.17,225Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.62,226.35v1.17a.32.32,0,0,1-.32.32.31.31,0,0,1-.31-.26,1.32,1.32,0,0,1-.8.26,1.42,1.42,0,0,1-1-.44,1.59,1.59,0,0,1,0-2.11,1.39,1.39,0,0,1,1.83-.19.31.31,0,0,1,.31-.26.32.32,0,0,1,.32.32Zm-.64,0a.89.89,0,0,0-.23-.62.73.73,0,0,0-.56-.25.7.7,0,0,0-.56.25.85.85,0,0,0-.23.62.85.85,0,0,0,.23.61.73.73,0,0,0,.56.24.76.76,0,0,0,.56-.24A.9.9,0,0,0,173,226.35Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.31,226.08v1.44a.32.32,0,0,1-.32.32.33.33,0,0,1-.33-.32v-1.44a.61.61,0,0,0-1.22,0v1.42s0,0,0,0h0l0,0v0a.34.34,0,0,1-.3.19h-.06a.34.34,0,0,1-.26-.32V226.1h0v-.93a.32.32,0,0,1,.32-.32.3.3,0,0,1,.29.18,1.21,1.21,0,0,1,.64-.18,1.25,1.25,0,0,1,1,.41,1.22,1.22,0,0,1,.94-.41,1.25,1.25,0,0,1,1.25,1.26v1.42a.32.32,0,0,1-.32.32.32.32,0,0,1-.32-.32V226.1a.62.62,0,0,0-1.23,0Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.3,226.34a1.48,1.48,0,0,1,1.46-1.5,1.43,1.43,0,0,1,1.45,1.39v.09a.3.3,0,0,1-.32.24H181a.79.79,0,0,0,.21.39.83.83,0,0,0,.57.27.94.94,0,0,0,.63-.15.34.34,0,0,1,.45,0,.27.27,0,0,1,0,.39,1.51,1.51,0,0,1-1.08.39A1.48,1.48,0,0,1,180.3,226.34Zm.65-.29h1.7a1,1,0,0,0-.89-.64A.84.84,0,0,0,181,226.05Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.88,
    y: 231.49,
    width: 115.13,
    height: 9.69,
    style: {
      fill: "#F9BF21",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.51,253.75V250.2a.32.32,0,0,1,.33-.33h2a.34.34,0,0,1,.34.33.34.34,0,0,1-.34.34h-1.62v1.1h1.4a.33.33,0,1,1,0,.66h-1.4v1.11h1.62a.34.34,0,1,1,0,.67h-1.94s0,0,0,0h0A.33.33,0,0,1,166.51,253.75Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.52,252.32h0v1.43a.33.33,0,0,1-.32.32.34.34,0,0,1-.33-.32v-1.43h0a.61.61,0,1,0-1.22,0v1.43s0,0,0,0v0s0,0,0,0v0a.35.35,0,0,1-.3.19h-.06a.32.32,0,0,1-.26-.31v-1.43h0v-.93a.32.32,0,0,1,.32-.33.31.31,0,0,1,.29.18,1.32,1.32,0,0,1,.65-.18,1.25,1.25,0,0,1,.94.42,1.22,1.22,0,0,1,.94-.42,1.26,1.26,0,0,1,1.25,1.26v1.43a.32.32,0,0,1-.32.32.33.33,0,0,1-.32-.32v-1.43a.62.62,0,0,0-1.23,0Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.26,252.58v1.18a.32.32,0,0,1-.32.32.34.34,0,0,1-.31-.26,1.38,1.38,0,0,1-1.82-.18,1.54,1.54,0,0,1-.41-1.06,1.52,1.52,0,0,1,.41-1.06,1.4,1.4,0,0,1,1-.45,1.33,1.33,0,0,1,.8.27.34.34,0,0,1,.31-.27.32.32,0,0,1,.32.33Zm-.64,0a.91.91,0,0,0-.23-.62.75.75,0,0,0-.56-.25.73.73,0,0,0-.56.25.91.91,0,0,0-.23.62.93.93,0,0,0,.23.62.75.75,0,0,0,.56.23.77.77,0,0,0,.56-.23A.93.93,0,0,0,177.62,252.58Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.09,250.32a.32.32,0,0,1-.32.33.33.33,0,0,1-.33-.33v-.13a.32.32,0,0,1,.33-.32.32.32,0,0,1,.32.32Zm0,1.09v2.34a.32.32,0,0,1-.32.33.33.33,0,0,1-.33-.33v-2.34a.33.33,0,0,1,.33-.33A.32.32,0,0,1,180.09,251.41Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.37,249.87a.34.34,0,0,1,.34.33v3.55a.34.34,0,0,1-.67,0V250.2A.33.33,0,0,1,181.37,249.87Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.84,252.58v1.18a.32.32,0,0,1-.32.32.34.34,0,0,1-.31-.26,1.38,1.38,0,0,1-1.82-.18,1.54,1.54,0,0,1-.41-1.06,1.52,1.52,0,0,1,.41-1.06,1.4,1.4,0,0,1,1-.45,1.33,1.33,0,0,1,.8.27.34.34,0,0,1,.31-.27.32.32,0,0,1,.32.33Zm-.64,0A.91.91,0,0,0,186,252a.77.77,0,0,0-.56-.25.73.73,0,0,0-.56.25.91.91,0,0,0-.23.62.93.93,0,0,0,.23.62.75.75,0,0,0,.56.23.79.79,0,0,0,.56-.23A.93.93,0,0,0,186.2,252.58Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.74,253.75a.32.32,0,0,1-.64.07,1.53,1.53,0,0,1-.82.26,1.51,1.51,0,0,1,0-3,1.52,1.52,0,0,1,.81.25v-1.13a.33.33,0,0,1,.65,0v2.38h0Zm-1.46-2a.8.8,0,0,0-.57.24.86.86,0,0,0-.24.61.87.87,0,0,0,.24.6.8.8,0,0,0,.57.24.78.78,0,0,0,.56-.24.88.88,0,0,0,.25-.6.87.87,0,0,0-.25-.61A.78.78,0,0,0,189.28,251.73Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.83,251.39a.31.31,0,0,1-.31.32.55.55,0,0,0-.36.11.86.86,0,0,0-.28.29,1.64,1.64,0,0,0-.25.51v1.14a.33.33,0,0,1-.65,0v-2.37a.33.33,0,0,1,.65,0v0l.13-.12a1.32,1.32,0,0,1,.76-.23A.31.31,0,0,1,193.83,251.39Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.11,252.57a1.49,1.49,0,0,1,1.47-1.5,1.42,1.42,0,0,1,1.44,1.4v.08a.3.3,0,0,1-.31.24h-1.92a.82.82,0,0,0,.21.4,1,1,0,0,0,1.2.12.34.34,0,0,1,.45,0,.27.27,0,0,1,0,.39,1.51,1.51,0,0,1-1.07.4A1.49,1.49,0,0,1,194.11,252.57Zm.65-.29h1.71a1,1,0,0,0-.89-.64A.85.85,0,0,0,194.76,252.28Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.84,253.22a.31.31,0,0,1,.45-.05,1.06,1.06,0,0,0,.66.26.83.83,0,0,0,.41-.11.24.24,0,0,0,.1-.18.11.11,0,0,0,0-.06.19.19,0,0,0-.08-.07,1.44,1.44,0,0,0-.48-.17h0a2.44,2.44,0,0,1-.52-.16,1,1,0,0,1-.42-.35.77.77,0,0,1-.1-.38.85.85,0,0,1,.36-.66,1.31,1.31,0,0,1,.73-.22,1.6,1.6,0,0,1,.91.33.34.34,0,0,1,.09.45.32.32,0,0,1-.44.08,1,1,0,0,0-.56-.22.62.62,0,0,0-.36.11.18.18,0,0,0-.09.13.07.07,0,0,0,0,.05.14.14,0,0,0,.07.06,1.15,1.15,0,0,0,.44.15h0a2.16,2.16,0,0,1,.56.18.89.89,0,0,1,.42.35.72.72,0,0,1,.12.4.88.88,0,0,1-.38.7,1.38,1.38,0,0,1-.78.24,1.78,1.78,0,0,1-1.07-.42A.31.31,0,0,1,197.84,253.22Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.73,253.22a.31.31,0,0,1,.45-.05,1.1,1.1,0,0,0,.66.26.77.77,0,0,0,.41-.11.23.23,0,0,0,.11-.18.11.11,0,0,0,0-.06s0,0-.08-.07a1.29,1.29,0,0,0-.48-.17h0a2.74,2.74,0,0,1-.53-.16,1,1,0,0,1-.41-.35.67.67,0,0,1-.1-.38.84.84,0,0,1,.35-.66,1.32,1.32,0,0,1,.74-.22,1.53,1.53,0,0,1,.9.33.33.33,0,0,1,.1.45.33.33,0,0,1-.45.08,1,1,0,0,0-.55-.22.62.62,0,0,0-.36.11c-.08.05-.1.1-.1.13s0,0,0,.05a.11.11,0,0,0,.06.06,1.22,1.22,0,0,0,.44.15h0a2,2,0,0,1,.56.18.91.91,0,0,1,.43.35.8.8,0,0,1,.11.4.88.88,0,0,1-.38.7,1.34,1.34,0,0,1-.78.24,1.78,1.78,0,0,1-1.07-.42A.32.32,0,0,1,200.73,253.22Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.88,
    y: 257.72,
    width: 115.13,
    height: 9.69,
    style: {
      fill: "#F9BF21",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.44,276.67l-1.24,1.69V280a.32.32,0,0,1-.33.33.33.33,0,0,1-.33-.33v-1.62l-1.22-1.69a.32.32,0,0,1,.07-.46.31.31,0,0,1,.45.07l1,1.41,1-1.41a.32.32,0,0,1,.46-.07A.33.33,0,0,1,169.44,276.67Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.69,279.87a1.5,1.5,0,0,1-.42-1.06,1.56,1.56,0,0,1,.42-1.05,1.41,1.41,0,0,1,1-.45,1.31,1.31,0,0,1,1,.45,1.53,1.53,0,0,1,.43,1.05,1.46,1.46,0,0,1-.43,1.06,1.32,1.32,0,0,1-1,.46A1.41,1.41,0,0,1,169.69,279.87Zm.24-1.06a1,1,0,0,0,.21.64.79.79,0,0,0,.58.22.75.75,0,0,0,.55-.22.94.94,0,0,0,.24-.64.9.9,0,0,0-.24-.62.85.85,0,0,0-.55-.23.89.89,0,0,0-.58.23A1,1,0,0,0,169.93,278.81Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.26,280.31a1.25,1.25,0,0,1-1.25-1.25v-1.44a.32.32,0,0,1,.64,0v1.44a.61.61,0,0,0,.61.61.62.62,0,0,0,.63-.61v-1.44a.31.31,0,0,1,.31-.31.34.34,0,0,1,.33.31v1.44A1.27,1.27,0,0,1,174.26,280.31Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.6,277.62a.32.32,0,0,1-.32.32.6.6,0,0,0-.36.12.9.9,0,0,0-.27.28,1.88,1.88,0,0,0-.25.51V280a.33.33,0,0,1-.65,0v-2.37a.33.33,0,0,1,.65,0v.05a.71.71,0,0,1,.13-.12,1.29,1.29,0,0,1,.75-.24A.31.31,0,0,1,178.6,277.62Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.71,278.55V280a.32.32,0,0,1-.32.32.33.33,0,0,1-.33-.32v-1.44a.61.61,0,0,0-.62-.6.61.61,0,0,0-.6.62v1.48s0,0,0,0v0a.34.34,0,0,1-.3.19h-.06a.34.34,0,0,1-.26-.32v-1.42h0v-.93a.32.32,0,0,1,.32-.32.3.3,0,0,1,.29.18,1.19,1.19,0,0,1,.64-.18,1.25,1.25,0,0,1,.95.41,1.22,1.22,0,0,1,.94-.41,1.25,1.25,0,0,1,1.25,1.26V280a.32.32,0,0,1-.32.32.32.32,0,0,1-.32-.32v-1.42a.62.62,0,0,0-1.23,0Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.7,278.81a1.48,1.48,0,0,1,1.46-1.5,1.44,1.44,0,0,1,1.45,1.39v.08a.29.29,0,0,1-.32.24h-1.91a.78.78,0,0,0,.21.4.88.88,0,0,0,.57.27.94.94,0,0,0,.63-.15.35.35,0,0,1,.45,0,.27.27,0,0,1,0,.39,1.54,1.54,0,0,1-1.08.4A1.48,1.48,0,0,1,186.7,278.81Zm.65-.3h1.7a1,1,0,0,0-.89-.63A.84.84,0,0,0,187.35,278.51Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.42,279.45a.32.32,0,0,1,.45-.05,1.12,1.12,0,0,0,.66.27.77.77,0,0,0,.41-.12.23.23,0,0,0,.11-.18.11.11,0,0,0,0-.06s0,0-.08-.07a1.29,1.29,0,0,0-.48-.17h0a2.18,2.18,0,0,1-.53-.15,1.06,1.06,0,0,1-.41-.35.7.7,0,0,1-.1-.38.83.83,0,0,1,.35-.66,1.24,1.24,0,0,1,.74-.22,1.47,1.47,0,0,1,.9.33.31.31,0,1,1-.35.52,1.07,1.07,0,0,0-.55-.22.62.62,0,0,0-.36.11.18.18,0,0,0-.1.14.06.06,0,0,0,0,.05l.06.06a1.25,1.25,0,0,0,.44.14h0a2,2,0,0,1,.56.17.93.93,0,0,1,.43.36.77.77,0,0,1,.11.39.86.86,0,0,1-.38.7,1.34,1.34,0,0,1-.78.24,1.72,1.72,0,0,1-1.07-.41A.33.33,0,0,1,190.42,279.45Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.32,279.45a.32.32,0,0,1,.45-.05,1.07,1.07,0,0,0,.66.27.83.83,0,0,0,.41-.12.26.26,0,0,0,.11-.18.11.11,0,0,0,0-.06.31.31,0,0,0-.08-.07,1.29,1.29,0,0,0-.48-.17h0a2.23,2.23,0,0,1-.52-.15,1.08,1.08,0,0,1-.42-.35.8.8,0,0,1-.1-.38.84.84,0,0,1,.36-.66,1.24,1.24,0,0,1,.74-.22,1.5,1.5,0,0,1,.9.33.32.32,0,0,1,.09.44.31.31,0,0,1-.44.08,1.07,1.07,0,0,0-.55-.22.59.59,0,0,0-.36.11.18.18,0,0,0-.1.14.09.09,0,0,0,0,.05l.07.06a1.18,1.18,0,0,0,.44.14h0a2.14,2.14,0,0,1,.56.17.91.91,0,0,1,.42.36.69.69,0,0,1,.12.39.86.86,0,0,1-.38.7,1.38,1.38,0,0,1-.78.24,1.72,1.72,0,0,1-1.07-.41A.33.33,0,0,1,193.32,279.45Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,278.81V280a.32.32,0,0,1-.32.32.31.31,0,0,1-.31-.26,1.32,1.32,0,0,1-.8.26,1.4,1.4,0,0,1-1-.44,1.52,1.52,0,0,1-.41-1.06,1.5,1.5,0,0,1,.41-1.05,1.37,1.37,0,0,1,1-.45,1.39,1.39,0,0,1,.8.26.31.31,0,0,1,.31-.26.32.32,0,0,1,.32.32Zm-.64,0a.91.91,0,0,0-.23-.62.76.76,0,0,0-.56-.24.73.73,0,0,0-.56.24,1,1,0,0,0,0,1.24.76.76,0,0,0,.56.24.8.8,0,0,0,.56-.24A.91.91,0,0,0,198.32,278.81Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,278.83v1.11a1.45,1.45,0,0,1-1.44,1.45,1.5,1.5,0,0,1-.63-.15.32.32,0,0,1-.14-.44.32.32,0,0,1,.43-.15.67.67,0,0,0,.34.09.81.81,0,0,0,.79-.65,1.33,1.33,0,0,1-.79.25,1.39,1.39,0,0,1-1-.46,1.51,1.51,0,0,1-.42-1.06,1.58,1.58,0,0,1,.42-1.07,1.41,1.41,0,0,1,1-.44,1.37,1.37,0,0,1,.81.25.31.31,0,0,1,.32-.25.31.31,0,0,1,.31.31v1.2Zm-.64,0a.93.93,0,0,0-.23-.61.73.73,0,0,0-.57-.26.71.71,0,0,0-.55.26.91.91,0,0,0,0,1.23.73.73,0,0,0,.55.25.76.76,0,0,0,.57-.25A.94.94,0,0,0,202.39,278.82Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.1,278.81a1.49,1.49,0,0,1,1.47-1.5A1.44,1.44,0,0,1,207,278.7v0s0,0,0,0a.28.28,0,0,1-.31.24h-1.91a.76.76,0,0,0,.2.4,1,1,0,0,0,1.2.12.35.35,0,0,1,.45,0,.27.27,0,0,1,0,.39,1.51,1.51,0,0,1-1.07.4A1.49,1.49,0,0,1,204.1,278.81Zm.66-.3h1.7a1,1,0,0,0-.89-.63A.83.83,0,0,0,204.76,278.51Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.88,
    y: 283.96,
    width: 115.13,
    height: 49.45,
    style: {
      fill: "#F9BF21",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,164.59a10,10,0,0,1-1.7-5.5c0-7,7.65-12.6,17.07-12.6s17.06,5.64,17.06,12.6-7.64,12.6-17.06,12.6a20.51,20.51,0,0,1-11.77-3.48l-5.88,1.49Z",
    style: {
      fill: "#F9BF21"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.89,145.47a12.38,12.38,0,0,0,2.12-6.85c0-8.67-9.53-15.71-21.27-15.71s-21.27,7-21.27,15.71,9.52,15.71,21.27,15.71A25.58,25.58,0,0,0,225.41,150l7.33,1.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.89,145.47a12.5,12.5,0,0,0,2-6.48,12.09,12.09,0,0,0-1.79-6.5,19.34,19.34,0,0,0-10.75-7.94,28.42,28.42,0,0,0-13.49-.88,22.33,22.33,0,0,0-12,5.9,13.92,13.92,0,0,0-3.51,5.65,11.38,11.38,0,0,0-.09,6.59,14,14,0,0,0,3.42,5.72,20,20,0,0,0,5.49,3.92,24.81,24.81,0,0,0,6.46,2.1,28.7,28.7,0,0,0,6.8.46,25.05,25.05,0,0,0,12.85-4.16l.07,0,.07,0,7.31,2-.1.11Zm0,0,2.92,6.35.07.15-.16,0-7.35-1.78.14,0a25.38,25.38,0,0,1-13,4.42A27.32,27.32,0,0,1,198.91,152a20.44,20.44,0,0,1-5.69-4,14.57,14.57,0,0,1-3.62-6,12,12,0,0,1,.07-7,14.65,14.65,0,0,1,3.71-5.94,20.62,20.62,0,0,1,5.74-4,25.12,25.12,0,0,1,6.66-2.07,29.4,29.4,0,0,1,6.95-.34,28.68,28.68,0,0,1,6.81,1.37,22.38,22.38,0,0,1,6.19,3.17,16.57,16.57,0,0,1,4.68,5.11,12.15,12.15,0,0,1-.52,13.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.81,
    y: 362.6,
    width: 59.28,
    height: 17.97,
    style: {
      fill: "#F9BF21"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.52,373.39a.62.62,0,0,1,.87-.08,3.88,3.88,0,0,0,2.29.92,2.61,2.61,0,0,0,1.5-.44,1.07,1.07,0,0,0,.52-.86.71.71,0,0,0-.11-.39,1.11,1.11,0,0,0-.36-.36,4.78,4.78,0,0,0-1.64-.56h0a6.31,6.31,0,0,1-1.54-.47,2.5,2.5,0,0,1-1.12-.93,1.87,1.87,0,0,1-.28-1,2.22,2.22,0,0,1,1-1.75,3.56,3.56,0,0,1,2.08-.63,4.65,4.65,0,0,1,2.61,1,.62.62,0,0,1-.68,1,3.46,3.46,0,0,0-1.93-.77,2.27,2.27,0,0,0-1.34.41.94.94,0,0,0-.46.75.59.59,0,0,0,.08.34,1.25,1.25,0,0,0,.33.31,4,4,0,0,0,1.5.53h0a7,7,0,0,1,1.66.5,2.8,2.8,0,0,1,1.2,1,1.9,1.9,0,0,1,.28,1,2.34,2.34,0,0,1-1,1.86,3.75,3.75,0,0,1-2.22.68,5.19,5.19,0,0,1-3.07-1.2A.64.64,0,0,1,209.52,373.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.23,372.48a3,3,0,0,1,2.93-3,2.88,2.88,0,0,1,2.89,2.79v.06a.45.45,0,0,1,0,.11.58.58,0,0,1-.63.47H218.6a1.58,1.58,0,0,0,.41.8,1.91,1.91,0,0,0,1.15.54,2.06,2.06,0,0,0,1.25-.3.68.68,0,0,1,.9,0,.56.56,0,0,1,0,.78,3,3,0,0,1-2.15.79A3,3,0,0,1,217.23,372.48Zm1.31-.58h3.4a2,2,0,0,0-1.78-1.28A1.68,1.68,0,0,0,218.54,371.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,372v2.87a.63.63,0,0,1-.62.63.65.65,0,0,1-.64-.63V372a1.23,1.23,0,0,0-1.24-1.21,1.19,1.19,0,0,0-1.2,1.21v2.87a.21.21,0,0,1,0,.12.65.65,0,0,1-.63.51.64.64,0,0,1-.64-.63v-4.73a.64.64,0,0,1,1.22-.26,2.41,2.41,0,0,1,1.28-.38A2.51,2.51,0,0,1,230,372Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.51,374.83a.66.66,0,0,1-.65.65.65.65,0,0,1-.63-.51,3,3,0,1,1-1.63-5.49,2.84,2.84,0,0,1,1.6.51v-2.26a.66.66,0,0,1,1.31,0v4.75h0Zm-2.91-4a1.55,1.55,0,0,0-1.13.49,1.72,1.72,0,0,0-.48,1.21,1.69,1.69,0,0,0,.48,1.19,1.55,1.55,0,0,0,1.13.49,1.53,1.53,0,0,0,1.12-.49,1.69,1.69,0,0,0,.48-1.19,1.72,1.72,0,0,0-.48-1.21A1.53,1.53,0,0,0,234.6,370.79Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.57,431.27c-1.91-1.37-39.26-53-39.43-55.89-.08-1.09,7.13-7,16-13.82,1.92-1.48,28.28-31.73,28.28-31.73l24.44,33.59-28.54,31.37s5.45,26.17,5.31,29.34S335.48,432.63,333.57,431.27Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.57,431.27c-1.91-1.37-39.26-53-39.43-55.89-.08-1.09,7.13-7,16-13.82.67-.52,4.34-4.58,8.84-9.62l24.17,33.15-8.83,9.7s5.44,26.17,5.31,29.33S335.48,432.63,333.57,431.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.62,431.48c-1.92-1.38-39.48-53.31-39.66-56.2-.07-1.07,7-6.58,15.27-13.89,2-1.76,3.77-4,6-5.71l24.53,33.72-5.37,5.39s5.48,26.32,5.34,29.51S335.54,432.85,333.62,431.48Z",
    style: {
      fill: "#F9BF21"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.16,429.23c-6.09-8.86-31.46-44-38.14-52.32-.06-.07-.1,0-.06,0,5.84,8.91,31.49,43.87,38.05,52.38C335.15,429.51,335.28,429.42,335.16,429.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.22,394.62c-1.84-3.89-5.4-7.7-9.73-8.55-.17,0-.21.21-.1.29a60,60,0,0,1,9.39,8.56A.27.27,0,0,0,337.22,394.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.52,398.17c-1.84-3.89-5.4-7.69-9.73-8.55-.17,0-.21.21-.1.29a59.49,59.49,0,0,1,9.38,8.56A.27.27,0,0,0,337.52,398.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.82,401.72c-1.84-3.88-5.4-7.69-9.73-8.55-.17,0-.22.21-.1.3a59,59,0,0,1,9.38,8.55A.27.27,0,0,0,337.82,401.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.11,405.28c-1.83-3.89-5.39-7.7-9.73-8.56-.16,0-.21.21-.09.3a59.87,59.87,0,0,1,9.38,8.55A.27.27,0,0,0,338.11,405.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.72,395.22c.88-2.69-1.77-4.59-4-5.15a22.53,22.53,0,0,0-11.67.4c-.09,0-.09.1-.06.17a.52.52,0,0,0,0,.84c3.09,2.08,6.14,4.67,9.78,5.73C345.85,397.83,348.89,397.76,349.72,395.22Zm-10.44-1.55c-1.55-1-3-2-4.62-3,2.28-.07,4.54-.24,6.82-.09a25.39,25.39,0,0,1,3.27.4c1.67.35,6.56,3,2.37,5.07C344.8,397.26,341.12,394.84,339.28,393.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.65,381.11c.84,3.7,3.25,6.9,5.13,10.11a.51.51,0,0,0,.84,0,.12.12,0,0,0,.18-.05,22.53,22.53,0,0,0,1.1-11.62c-.42-2.26-2.16-5-4.9-4.31C328.41,375.93,328.16,379,328.65,381.11ZM330,377.8c2.37-4.06,4.68,1,4.92,2.66a24.17,24.17,0,0,1,.2,3.3c0,2.28-.29,4.53-.49,6.8-.83-1.64-1.79-3.19-2.68-4.79C330.87,383.86,328.67,380,330,377.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,299.94c-2.31,11.43-40.22,47.35-40.22,47.35l33.06,38.16s57.81-57.52,54.3-82.77c-3.06-22-35.94-110.29-35.94-110.29H331.28S360.3,288.7,358,299.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,299.94c-2.31,11.43-40.22,47.35-40.22,47.35l33.06,38.16s57.81-57.52,54.3-82.77c-3.06-22-35.94-110.29-35.94-110.29H331.28S360.3,288.7,358,299.94Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.62,376.37c-4.39-5.46-3.06-4-7.51-9.37-2.18-2.66-16.52-20.07-19-22.18-.06-.05-.15,0-.11.09,1.65,2.8,16.29,20,18.52,22.56,4.56,5.34,3.31,3.76,7.92,9C354.55,376.61,354.7,376.48,354.62,376.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.73,294.37c-.54-2.85-1.15-5.7-1.76-8.54q-1.85-8.7-3.91-17.35-4.11-17.18-8.92-34.14c-3.23-11.36-6.65-22.69-10.59-33.82-.48-1.38-1-2.75-1.49-4.12a.08.08,0,0,0-.16,0c3.41,11.15,6.92,22.27,10.12,33.49s6.13,22.4,8.91,33.67c1.39,5.67,2.69,11.35,4,17q.93,4.2,1.82,8.4a58.1,58.1,0,0,1,1.59,8.66,13.12,13.12,0,0,1-2.23,7.79c-1.42,2.33-3.09,4.52-4.71,6.71-3.24,4.4-24.61,29.13-25.61,30.06-.07.07.05.18.12.11C334,338.66,350.71,320,354,315.6q2.46-3.25,4.82-6.6a25.7,25.7,0,0,0,3.77-6.64A15.57,15.57,0,0,0,362.73,294.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.66,192.39l-6.89,90.38c-6.57-30.93-24.48-90.38-24.48-90.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.47,440.8c-2.23.74-66,.48-68.4-1.07-.92-.57-1.42-9.87-1.71-21.1-.07-2.43-9-41.55-9-41.55l41.53.05,8.53,41.54s24.36,11,26.84,13S431.69,440.06,429.47,440.8Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.46,440.8c-2.22.74-66,.48-68.38-1.07-.93-.58-1.43-9.86-1.72-21.1,0-.85-1.14-6.21-2.57-12.81h41l2.64,12.85s24.35,11,26.83,13S431.69,440.06,429.46,440.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.66,440.89c-2.24.74-66.34.48-68.77-1.07-.91-.58-1.2-9.54-2.22-20.52-.25-2.65-1-5.42-1.08-8.22l41.7,0,1.19,7.52s24.5,11.08,27,13.07S431.9,440.15,429.66,440.89Z",
    style: {
      fill: "#F9BF21"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.66,440.89c-2.24.74-66.34.48-68.77-1.07-.91-.58-1.2-9.54-2.22-20.52-.25-2.65-1-5.42-1.08-8.22l41.7,0,1.19,7.52s24.5,11.08,27,13.07S431.9,440.15,429.66,440.89Z",
    style: {
      fill: "#F9BF21"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.75,438.32c-10.74-.31-54.1-.53-64.74,0-.09,0-.09.06,0,.06,10.64.54,54,.41,64.74.13C429,438.49,429,438.33,428.75,438.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402,416.26c-4.23-.8-9.4-.18-12.64,2.82-.13.12,0,.3.17.25A59.93,59.93,0,0,1,402,416.8.27.27,0,0,0,402,416.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.05,418.11c-4.22-.8-9.4-.17-12.64,2.82-.13.12,0,.3.18.26A59.09,59.09,0,0,1,405,418.65.27.27,0,0,0,405.05,418.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.1,420c-4.23-.8-9.4-.17-12.65,2.83-.12.11.05.29.18.25a59.31,59.31,0,0,1,12.45-2.54A.27.27,0,0,0,408.1,420Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.14,421.82c-4.22-.81-9.4-.18-12.64,2.82-.13.11,0,.29.18.25a59.09,59.09,0,0,1,12.44-2.54A.27.27,0,0,0,411.14,421.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.85,406.51c-1.65-2.29-4.75-1.27-6.52.2a22.72,22.72,0,0,0-6.55,9.66.11.11,0,0,0,.1.15c0,.33.3.67.66.54,3.5-1.28,7.4-2.22,10.4-4.53C409.69,411.18,411.42,408.69,409.85,406.51Zm-7.4,7.52c-1.71.67-3.43,1.26-5.11,2a67.4,67.4,0,0,1,4-5.56,24.4,24.4,0,0,1,2.25-2.41c1.26-1.14,6.25-3.55,5.49,1.08C408.6,411.69,404.48,413.23,402.45,414Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,415.23c3.48,1.49,7.49,1.44,11.19,1.81a.52.52,0,0,0,.51-.68.11.11,0,0,0,.06-.17,22.59,22.59,0,0,0-8.74-7.74c-2.08-1-5.33-1.21-6.37,1.42S384,414.35,386,415.23Zm-1.9-3c-1.88-4.3,3.55-3.19,5.05-2.4a23.83,23.83,0,0,1,2.78,1.78,66.39,66.39,0,0,1,5.2,4.4c-1.8-.29-3.62-.43-5.44-.66C389.57,415.05,385.19,414.58,384.14,412.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.8,192.39a156.47,156.47,0,0,0-3.26,18.93c-.79,7.94-1.78,15-2.84,15.84s-7.19,4.83-9.21,6.07c0,0,18.69,56.66,23.52,75.55,7,27.38,21.33,94,21.33,94H353.71S342.55,340.1,336.62,314c-5.09-22.35-24.57-89.4-24.57-89.4a38.91,38.91,0,0,1,1.58-32.24S368.81,192.36,368.8,192.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.92,394.17c-6.54,0-4.66-.13-11.2-.09-3.2,0-24.22.14-27.2.72-.06,0-.06.13,0,.14,3,.49,24,0,27.21-.12,6.54-.17,4.66-.19,11.19-.44C394,394.37,394,394.17,393.92,394.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.86,224.92a85.24,85.24,0,0,0-12.31,8.24.15.15,0,0,0,.17.25c4.17-2.61,8.44-5.16,12.47-8A.3.3,0,0,0,365.86,224.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.46,194.09c0-.15-.32-.15-.29,0a150,150,0,0,1,1.57,15c.15,2.34.27,15.35-3.86,15-.7,0-1.14-.65-1.4-1.64a16.11,16.11,0,0,1-.08-4c0-2.73,0-5.46-.22-8.19a73.63,73.63,0,0,0-2.5-15,.13.13,0,0,0-.25.06,140.45,140.45,0,0,1,2,21c0,3.39-.88,8.63,2.66,8.6s4.59-8.73,4.67-11.08A77.39,77.39,0,0,0,362.46,194.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,224.53a21.83,21.83,0,0,0-.48,2.78,5.93,5.93,0,0,0,0,2.22.16.16,0,0,0,.29,0,8.22,8.22,0,0,0,.6-2.25c.17-.87.37-1.73.52-2.59A.45.45,0,0,0,360,224.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.71,378.66c-.13-1.25-.29-2.51-.45-3.76-.32-2.4-4-21.92-5.89-31.42-1.08-5.38-2.35-10.69-3.68-16-.09-.37-.58-.19-.52.17.81,4.86,1.59,9.72,2.52,14.56s6.09,29.69,6.58,32.38c.24,1.35.49,2.69.76,4s.65,2.65.86,4c0,.13.2.07.18-.06C349.87,381.28,349.85,380,349.71,378.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.7,325.75c-1.48-7.41-3.49-14.71-5.5-22-4.06-14.64-8.83-29.07-13.59-43.5q-2.07-6.24-4.12-12.47c-.69-2.08-4.05-13.28-4.47-14.35a.09.09,0,0,0-.17.06c1,3.81,2.28,9.38,3.4,13.16s2.3,7.44,3.46,11.16c2.28,7.3,4.6,14.6,6.81,21.92,4.38,14.48,8.72,29,12.27,43.67,1,4.12,2,8.23,2.9,12.37s1.68,8.3,2.54,12.44a.11.11,0,0,0,.21,0C384.69,340.64,383.19,333.18,381.7,325.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354,364.48c-2.46-14.12-5.4-28.17-8.66-42.13s-6.92-28-10.94-41.81S325.89,253,321.1,239.4A173.61,173.61,0,0,1,315,219.83c-1.47-6.6-2.22-13.73-.68-20.39a33.43,33.43,0,0,1,1.53-5c0-.11-.12-.2-.17-.09-5.37,12.51-1.88,26.19,2.2,38.51,2.24,6.76,4.63,13.46,6.84,20.23q3.39,10.41,6.51,20.92c4.12,13.88,8,27.84,11.37,41.91s6.48,28.21,9.16,42.44,2.55,13.1,4.84,27.44c.3,1.87.54,3.74.78,5.62,0,.1.18.1.17,0C355.87,377.24,356.41,378.59,354,364.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.63,87.08l-4.18,27.49c-.21.82.24,1.42,1,1.35l13.85-1.34A2.23,2.23,0,0,0,409.1,113l4.19-27.49c.21-.82-.25-1.42-1-1.34l-13.85,1.33A2.23,2.23,0,0,0,396.63,87.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.28,86.91l-4.19,27.49c-.21.82.25,1.42,1,1.34L409,114.41a2.25,2.25,0,0,0,1.79-1.61l4.18-27.49c.21-.82-.25-1.42-1-1.35l-13.85,1.33A2.26,2.26,0,0,0,398.28,86.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.19,87.77A1.17,1.17,0,0,1,401.1,89a1.19,1.19,0,0,1-1.27-1.09,1.18,1.18,0,0,1,2.36-.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.83,131.45c9.3,16,31.36,37.61,38.66,37.07,3.47-.26,9.73,0,13.94-4.35,9.17-9.56,16-26.91,16.88-36.58.3-3.44-16.81-9.34-19-6.37-5.13,7-10.65,20.2-11.66,20.21-3.76,0-21.06-10.81-32.12-17.47C350.65,115.59,354.12,125.07,357.83,131.45Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.19,110.06c-2.34-6.72-4-8.09-2.94-14.81.68-4.41-1.85-6.74-4.61-3-4.51,6.11-3.31,15.42-2,18.52Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.76,130.61s2.23-9.85.45-17.26C426,108.23,422,97.38,407,92.79c-3.57-1.09-9.43-.11-4.24,3.78,3.68,2.77,6.85,3.42,8.7,5.42,0,0-7.31,2.12-8.26,5.74a68.42,68.42,0,0,0-1.81,9.63,13.67,13.67,0,0,0,1.77.51s-.57,3.46,2.3,8Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.25,108.65c-2.26-1.59-7.09-4.9-12-6.23-5.44-1.47-16.31-2.85-17.35,1.18-.77,3,3.33,3.84,3.33,3.84s-4.61.38-4.72,3.19c-.1,2.57,3.11,3.07,3.11,3.07s-2.76.71-2.38,3.2c.46,3,6.17,1,9.25,3.65C405.19,121.15,425.25,108.65,425.25,108.65Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.66,108.43a22.42,22.42,0,0,0-13.34-1.08c-.11,0-.15.13,0,.13a54.87,54.87,0,0,1,13.37,1A0,0,0,0,0,412.66,108.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411,113.87a25.19,25.19,0,0,0-13.38-.27c-.11,0-.14.13,0,.12a59.59,59.59,0,0,1,13.4.2S411,113.88,411,113.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.9,133.35l-10.24,22.18s-16.38-21.3-19.43-28.92c-3.43-8.58,1.71-8.46,9.81-5.06S382.9,133.35,382.9,133.35Z",
    style: {
      fill: "#F9BF21"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.9,133.35l-10.24,22.18s-16.38-21.3-19.43-28.92c-3.43-8.58,1.71-8.46,9.81-5.06S382.9,133.35,382.9,133.35Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.53,132.28c-1.68,2.65-5.62,11.3-6.29,12.73-.35.75-1.62,3.8-2,4.55,0,.09.11.15.15.05.68-1.42,1.51-2.78,2.2-4.2s5-10.08,6-13.07C378.66,132.27,378.57,132.22,378.53,132.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.23,203l66.37,2.27c-.05,1.3-1.93-52.11-18.09-84-1.1-2.18-11.45-4.83-16.2-.75C320.53,138.32,309.2,203.79,309.23,203Z",
    style: {
      fill: "#F9BF21"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.17,121.47l17.85.77a1.59,1.59,0,0,1,.15.29l-18.28-.78Zm-4.94,5.84,25.54,1.08a1.78,1.78,0,0,0-.12-.29L335.43,127Zm-3.56,5.6L363,134.24c0-.1-.06-.19-.1-.29l-31.06-1.32Zm-3,5.63,36.22,1.54-.09-.3-36-1.52Zm-2.59,5.64,40.49,1.72c0-.1-.05-.19-.08-.29l-40.29-1.7Zm-2.31,5.67,44.28,1.87c0-.1-.05-.19-.07-.29l-44.1-1.87C323.87,149.65,323.83,149.76,323.8,149.85Zm-2.09,5.66,47.67,2-.06-.29-47.51-2C321.78,155.31,321.75,155.41,321.71,155.51Zm-1.92,5.67,50.75,2.15-.05-.29-50.6-2.14A2.31,2.31,0,0,1,319.79,161.18ZM318,166.86l53.54,2.27a2.93,2.93,0,0,0-.05-.29l-53.41-2.27C318.08,166.68,318.05,166.77,318,166.86Zm-1.66,5.67,56.12,2.38c0-.1,0-.18-.05-.28l-56-2.37A2.76,2.76,0,0,1,316.37,172.53Zm-1.53,5.69,58.44,2.48a2.66,2.66,0,0,0,0-.28L314.91,178C314.89,178,314.86,178.13,314.84,178.22Zm-1.44,5.7L374,186.49a1.5,1.5,0,0,0,0-.29l-60.48-2.56C313.45,183.73,313.43,183.82,313.4,183.92Zm-1.34,5.7,62.53,2.64,0-.27-62.44-2.65Zm-1.26,5.7L375.1,198l0-.29L310.86,195Zm-1.17,5.7,65.87,2.79c0-.09,0-.19,0-.29l-65.8-2.78A2.74,2.74,0,0,0,309.63,201Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,129.09c-3.14.85-9.85-2.65-12.25-7.09-.17-.31.31-3.51.71-7.42.24-2.38.44-5,.45-7.47,0-.49,15.25,3.78,15.25,3.78a38.61,38.61,0,0,0-1.52,9.34,5.38,5.38,0,0,0,.1,1,.7.7,0,0,1,0,.16C359.08,123.29,359.37,128.17,356,129.09Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.77,121.23s0,.1,0,.16a10.91,10.91,0,0,1-1.56.08c-9-.24-11.3-11.5-11.75-14.35,2.71.4,14.71,3.77,14.71,3.77a38.61,38.61,0,0,0-1.52,9.34A5.28,5.28,0,0,0,358.77,121.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.18,88.16c-1.5,5.45,1.78,21,5.73,24.38,5.71,4.9,14.86,5.13,19-1.69,4-6.61-.66-26.8-5-29.85C355.38,76.51,344.4,80.1,342.18,88.16Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.68,97.1s-.07.06-.06.11c.25,1,.36,2.27-.52,2.82,0,0,0,.06,0,0C358.25,99.68,358.09,98,357.68,97.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.52,96.19c-1.71.22-1.15,3.63.44,3.43S358,96,356.52,96.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.83,96.26c0-.05.09,0,.09.08.14,1.06.48,2.25,1.5,2.44,0,0,0,.06,0,.06C364.23,98.87,363.79,97.28,363.83,96.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.59,95c1.67-.41,2.37,3,.82,3.35S363.18,95.34,364.59,95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.92,94.86c.44-.19.82-.45,1.24-.68a2.35,2.35,0,0,0,1.14-.94.75.75,0,0,0-.26-.86,1.82,1.82,0,0,0-1.84.12,2.62,2.62,0,0,0-1.32,1.38A.78.78,0,0,0,354.92,94.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.62,93.06c-.49,0-.93-.08-1.41-.12a2.34,2.34,0,0,1-1.42-.41.74.74,0,0,1-.1-.89,1.81,1.81,0,0,1,1.72-.63,2.7,2.7,0,0,1,1.77.74A.78.78,0,0,1,365.62,93.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.33,107.06a1.59,1.59,0,0,0,1,.47,2.75,2.75,0,0,0,1.09-.45,0,0,0,0,1,.06,0,1.43,1.43,0,0,1-1.25.79,1.13,1.13,0,0,1-1-.8C358.21,107.07,358.29,107,358.33,107.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.92,103.71a3.65,3.65,0,0,0,2.66,1.21,4.85,4.85,0,0,0,1.31-.16,1.09,1.09,0,0,0,.24-.07l.22-.07a.28.28,0,0,0,.18-.27h0a.43.43,0,0,0,0-.11h0l0-.09c-.11-.81-.4-2-.4-2,.32.1,1.95.53,1.86.11a55.74,55.74,0,0,0-3.2-10.65.1.1,0,0,0-.19.06c.63,3.38,1.85,6.62,2.53,10a6.4,6.4,0,0,0-1.78-.23c-.11.05.59,2.35.61,2.72a0,0,0,0,1,0,0,5,5,0,0,1-3.91-.54C358.91,103.56,358.84,103.64,358.92,103.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.34,104.43a4.36,4.36,0,0,1-1.49,1.61,2,2,0,0,1-1.16.26c-.88-.08-1-.85-1-1.54a5.12,5.12,0,0,1,.21-1.08A5.62,5.62,0,0,0,362.34,104.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.85,106a2,2,0,0,1-1.16.26c-.88-.08-1-.85-1-1.54A2,2,0,0,1,360.85,106Z",
    style: {
      fill: "#ff99ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.94,85.81c-.79-1.25-1.68-2.49-2.53-2.62s-1.06,1.92-2.88,2.34c-2.45.58-4-1.5-7.53-1.18-5,.48-6.54,5-5.5,12.07.93,6.33-2.78,7.55-2.78,7.55s-4.6-13.53-1.43-18.78,11.82-8.76,18.59-5.36C363.34,81.07,364.94,85.81,364.94,85.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.49,101s-3.77-4.88-6-3.51.77,8.56,3.5,9.43a2.74,2.74,0,0,0,3.6-1.64Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.4,99.49a0,0,0,0,0,0,.07c1.92.68,3,2.38,3.78,4.16a1.52,1.52,0,0,0-2.28-.31c-.05,0,0,.11.05.1a1.69,1.69,0,0,1,1.88.5,8,8,0,0,1,1,1.46c.1.16.4.06.32-.13v0C346,102.89,344,99.61,341.4,99.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.89,128.93c-9.63,12.75-30.06,37.79-28.14,49.49,2.12,13,10.52,33.51,16,39.43,1.3,1.42,8.66.78,14.31-2,4.61-2.31,7.83-6.57,7.81-8.26-.05-3.74-12.38-27.06-13.26-29.72s10.71-29.46,14.73-42.42C348.38,119.05,340.05,118.13,331.89,128.93Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.07,153.28,314,149s16.45-21.24,23.05-26.12c7.43-5.49,8.62-.49,7.39,8.21S338.07,153.28,338.07,153.28Z",
    style: {
      fill: "#F9BF21"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.07,153.28,314,149s16.45-21.24,23.05-26.12c7.43-5.49,8.62-.49,7.39,8.21S338.07,153.28,338.07,153.28Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,148.78c-3-1-12.36-2.58-13.91-2.86-.81-.15-4.09-.6-4.9-.76-.11,0-.12.15,0,.17,1.55.29,3.07.75,4.62,1.06s11,2.3,14.17,2.51C338,148.91,338.06,148.8,338,148.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.83,143.5c.54-1.18,1.08-2.35,1.57-3.54,0,0,0,0,0,0-.43.84-.84,1.7-1.24,2.56.52-1.82,1-3.65,1.41-5.49,0,0,0,0-.05,0-1,2.67-1.88,5.41-2.83,8.11s-1.83,5.31-2.72,8c-.56,0-1.12,0-1.68-.07a.09.09,0,0,0,0,.17c.6.13,1.2.27,1.79.43a.28.28,0,0,0,.36-.15C339.66,150.22,340.82,146.88,341.83,143.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.58,218.17a28,28,0,0,0,7.22-.43,35.94,35.94,0,0,0,6.83-2c4.38-1.59,7.73-5.19,9.78-9.69a13.53,13.53,0,0,1-2.84,7,14.12,14.12,0,0,1-6.2,4.58,24.11,24.11,0,0,1-7.38,1.71A16.07,16.07,0,0,1,318.58,218.17Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.0ecefa526dbc89399e18308cce50feb7.svg";
export { ForwardRef as ReactComponent };